import "ant-design-vue/es/notification/style";
import _notification from "ant-design-vue/es/notification";
import "core-js/modules/es.array.push.js";
import NavMenu from '@/components/NavMenu';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { getInfo, getLabel, queryLabel } from '@/api/modules/personal';
import { debounce } from '@/utils/index.js';
export default {
  components: {
    NavMenu
  },
  props: {
    logo: {
      type: Object
    },
    className: {
      type: String
    }
  },
  data() {
    return {
      noHeaderRouter: ['agreement'],
      scrollTop: 0,
      isLogin: false,
      customer_name: '',
      pageLoading: true,
      text: '',
      showContent: false,
      showList: true,
      recommedList: [],
      searchData: {
        component: [],
        interface: []
      },
      carShow: [],
      historyList: [],
      shoppingCarShow: false,
      count: 0
    };
  },
  computed: {
    ...mapGetters(['username', 'customername', 'useProduct', 'haslogin', 'userCode', 'list', 'productList']),
    routeName() {
      return this.$route.name;
    },
    changeBg() {
      const scrollHeight = 600;
      return this.scrollTop > scrollHeight;
    },
    productType() {
      if (this.productList.find(item => item.product_code === 'interface')) {
        if (Object.keys(this.productList.find(item => item.product_code === 'interface')).length > 0) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    ...mapActions({
      logout: 'user/logout'
    }),
    ...mapMutations({
      setUserCode: 'user/setUserCode'
    }),
    async handleLogout() {
      await this.logout();
    },
    // 获取热门标签
    getLabelData() {
      getLabel().then(res => {
        if (res.code === 1) {
          this.recommedList = res.result;
        }
      });
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.onSearch(this.text);
      }
    },
    onSearch(text) {
      let arr = JSON.parse(localStorage.getItem('historyList')) || [];
      if (text && arr.indexOf(text) === -1) {
        arr.unshift(text);
        localStorage.setItem('historyList', JSON.stringify(arr));
      }
      this.historyList = arr.slice(0, 10);
    },
    searchLabel(text) {
      this.pageLoading = true;
      queryLabel({
        query: text
      }).then(res => {
        if (res.code === 1) {
          this.pageLoading = false;
          this.searchData = {};
          // let obj = {}; let  arr = [];
          // res.result.category.forEach(item => {
          //   arr.push({
          //     associated_id: item.group_code,
          //     associated_name: item.group_name
          //   });
          // });
          // obj = {
          //   interface: res.result.interface.concat(...arr),
          //   component: res.result.component
          // };
          Object.assign(this.searchData, res.result);
        }
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    change(e) {
      this.text = e.target.value;
      if (e.target.value !== '') {
        debounce(this.searchLabel(e.target.value), 1000);
      }
    },
    toSearch(type, data) {
      this.text = data;
      this.searchLabel(data);
      if (type === 'recommend') {
        this.onSearch(data);
      }
    },
    toOpenai(type, data) {
      this.onSearch(data.associated_name);
      if (type === 'category') {
        this.$router.push({
          path: '/service/details',
          query: {
            type,
            group_code: data.group_code
          }
        });
      } else {
        this.$router.push({
          path: '/service/details',
          query: {
            type,
            _id: data.associated_id,
            group_code: data === null || data === void 0 ? void 0 : data.category[0].group_code
          }
        });
      }
      this.clear();
    },
    deleteHistory() {
      this.historyList = [];
      localStorage.setItem('historyList', JSON.stringify([]));
    },
    clickOrderListOutSide(e) {
      if (this.$refs.searchItem && !this.$refs.searchItem.contains(e.target)) {
        this.showContent = false;
        this.text = '';
      }
    },
    clear() {
      this.text = '';
      this.showList = true;
      this.showContent = false;
    },
    handleFocus() {
      this.showContent = true;
      document.addEventListener('click', this.clickOrderListOutSide, false);
    },
    notify() {
      this.count++;
      _notification.open({
        message: '账号异常',
        description: '您的账号已被冻结，无法正常进行体验与收藏等操作，可能是工作邮箱未认证通过，请联系对接的同花顺销售同事进行处理。',
        onClose: () => {
          this.$emit('move', this.count);
        },
        style: 'position:absolute;width:400px;height:150px;top:100px;right:10px'
      });
    },
    // showCar(){
    //   if (this.userCode){
    //     sessionStorage.setItem('component', JSON.stringify({
    //       id: this.list._id,
    //       key: this.list.category[0].group_code
    //     }));
    //     this.$router.push(
    //       '/service/details',
    //     );
    //   } else {
    //     this.notify();
    //   }
    // },
    toPersonal(type) {
      if (this.userCode) {
        if (type === 'product') {
          this.$router.push({
            path: '/service/personal',
            query: {
              tab: 'present'
            }
          });
        } else {
          this.$router.push('/service/personal');
        }
      } else {
        this.notify();
      }
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 控制header左右移动
      const left = document.documentElement.scrollLeft;
      const dom = document.getElementsByClassName('app-header')[0];
      if (this.$route.path === '/homepage') {
        dom.style.transform = `translateX(${-left}px)`;
      } else {
        dom.style.transform = 'translateX(0px)';
      }
    },
    jumpEnSite() {
      window.location.href = 'http://hithink.sg/#/Home';
    },
    goRegister() {
      this.$router.push({
        path: '/login',
        query: {
          register: true
        }
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOrderListOutSide, false);
  },
  mounted() {
    if (localStorage.getItem('historyList')) {
      this.historyList = JSON.parse(localStorage.getItem('historyList')).slice(0, 10);
    }
    if (this.haslogin) {
      this.getLabelData();
    }
    window.addEventListener('scroll', this.handleScroll);
    if (!this.userCode) {
      getInfo().then(res => {
        const no_active_code = 20000;
        if (res.code === 1) {
          this.setUserCode(true);
        } else if (res.code === no_active_code) {
          this.setUserCode(false);
        } else {
          console.log(res);
        }
      });
    }
  },
  watch: {
    // $route: {
    //   handler(n){
    //     if (n.path.indexOf('details') !== -1){
    //       this.carShow = false;
    //     } else {
    //       this.carShow = true;
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // },
    text: {
      handler(n) {
        if (n === '') {
          this.showList = true;
        } else {
          this.showList = false;
        }
      },
      deep: true,
      immediate: true
    }
  }
};